import React from 'react'
import { Box, Grid } from '@mui/material';
import { useStyle } from "./Style";
import SkeletonWrapper from '../../../../../containers/NewProductList/components/SkeletonWrapper/SkeletonWrapper';
import { formatDateLocale } from '../../../../../lib/utils.es6';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
const Notes = (props) => {

  const classes = useStyle();

  if (props.loader) {
    return <SkeletonWrapper loading={props.loader} />
  }


  if (props.notes.length === 0) {
    return <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12} className={classes.claimwrapper}>
        <Grid container spacing={2} className={classes.claimdetailswrapper}>
          <Grid item xs={12} sm={12} md={12} className={classes.ClaimDetailscontent}>
            <p style={{ textAlign: 'center', marginTop: "30px" }}>No details found</p>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  }else{
    // Sort notes by created_at descending (newest first)
    const sortedNotes = [...props.notes].sort((a, b) => {
      return new Date(b.created_at) - new Date(a.created_at);
    });

    return (
      <>
      {
            sortedNotes.map((note, index) => {
              const isAmendment = note.note && note.note.includes('AMENDMENT');
              return (
              <Grid container className={classes.policyWrapper} key={index}>
                <Grid item xs={12} sm={12} md={12}>
                  <Grid container className={classes.policyHeader}>
                    <Grid item xs={12} sm={12} md={12}>
                      <Grid container>
                        <Grid item xs={12} md={1} sm={1} className={classes.policyIconWrapper}   >
                          <Box className={classes.policyIcons}>
                            <InsertDriveFileOutlinedIcon fontSize="14px" sx={{ color: "#ffffff" }} />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={11} sm={11} className={classes.policyHeaderContent}>
                          <div className={`noteContent ${isAmendment ? 'noteAmendment' : ''}`} style={{ marginBottom: '10px' }}>
                            {note.note || "N/A"}
                          </div>
                          <p style={{
                            fontSize: '10px',
                            color: '#999',
                            margin: 0,
                            fontStyle: 'italic'
                          }}>
                            Note Details
                          </p>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} style={{ marginTop: '15px', paddingTop: '15px', paddingBottom: '15px', borderTop: '1px solid #e0e0e0' }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} sm={6}>
                          <div style={{ paddingLeft: '15px' }}>
                            <p style={{
                              fontFamily: 'Open Sans',
                              fontSize: '10px',
                              color: '#666',
                              marginBottom: '5px',
                              fontWeight: 600
                            }}>
                              Created At
                            </p>
                            <h6 style={{
                              fontFamily: 'Lato',
                              fontSize: '12px',
                              color: '#000',
                              margin: 0
                            }}>
                              {formatDateLocale(note.created_at) || "N/A"}
                            </h6>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6} sm={6}>
                          <div style={{ paddingLeft: '15px' }}>
                            <p style={{
                              fontFamily: 'Open Sans',
                              fontSize: '10px',
                              color: '#666',
                              marginBottom: '5px',
                              fontWeight: 600
                            }}>
                              Created By
                            </p>
                            <h6 style={{
                              fontFamily: 'Lato',
                              fontSize: '12px',
                              color: '#000',
                              margin: 0
                            }}>
                              {note.web_user || "N/A"}
                            </h6>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              );
            })
      }
      </>
    )
  }


  
 
}

export default Notes